// export const api_url = "http://localhost:8000";
// export const api_url = "https://frrlancejobportapi.onrender.com";
export const api_url = "https://api.lawvs.com";
